import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';
import {
  SAMPLE_PROJECT_ACCOUNT_ID,
  TEMPLATES_PATH,
} from 'routes/routes.constants';

export { SAMPLE_PROJECT_ACCOUNT_ID };

const TEMPLATES_SEGMENT = TEMPLATES_PATH.slice(1);

export const useRouteParams = () => {
  const location = useLocation();

  return useMemo(() => {
    const segments = location.pathname.split('/');

    // Handle agent-wizard routes: /agent-wizard/{accountId}/{projectId}/voice
    if (segments[1] === 'agent-wizard') {
      return {
        accountId: segments[2],
        projectId: segments[3],
      };
    }

    if (segments[1] === TEMPLATES_SEGMENT && segments[2]) {
      return {
        accountId: SAMPLE_PROJECT_ACCOUNT_ID,
        projectId: segments[2],
      };
    }

    const [_, accountId, projectId, _route] = segments;
    return {
      accountId,
      projectId,
    };
  }, [location.pathname]);
};
